export default __webpack_public_path__ + "static/media/AfterPhoto13.24eb6a55.JPG";